import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { } from "react";

interface PrintSellsProps {
  title?: string;
  date?: string;
  data: any[];
}

const PrintSells = React.forwardRef((props: PrintSellsProps, ref) => {
  return (
    <Box ref={ref} sx={{
      margin: 0,
      width: "100%",
      borderCollapse: "collapse",
      textAlign: 'center',
      paddingLeft: '20px',
      paddingRight: '20px',
      '&@page': {
        size: 'A4 portrait',
      },
      overflow: 'hidden',
      fontSize: 8,
      display: 'block',
      pageBreakBefore: 'auto', // Allow page break before this element 
    }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TableContainer >
            <Table sx={{ minWidth: 650, overflow: 'hidden' }}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={9} sx={{ textAlign: 'center', }}>
                    <Typography fontWeight={'bold'}>{props.title}</Typography>
                    <Typography>{props.date}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>วันที่</TableCell>
                  <TableCell>ชื่อ-นามสกุล</TableCell>
                  <TableCell>ชื่อโครงการ</TableCell>
                  <TableCell>บ้าน</TableCell>
                  <TableCell width={100}>บันทึก</TableCell>
                  <TableCell width={100}>แก้ไข</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.length > 0 && props?.data?.map((row: any) => (
                  <TableRow
                    key={row.id}
                  >
                    <TableCell>{dayjs(row.createDate).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{row?.booking?.customer?.firstname || ''} {row?.booking?.customer?.lastname || ''}</TableCell>
                    <TableCell>{row?.booking?.project?.name || ''}</TableCell>
                    <TableCell>{row?.booking?.house?.name || ''}</TableCell>
                    <TableCell>
                      {<b>{row.createBy?.name}</b>} {dayjs(row.createAt).format('DD/MM/YYYY HH:mm')}
                    </TableCell>
                    <TableCell>
                      {<b>{row.updateBy?.name}</b>} {row.updateAt ? dayjs(row.updateAt).format('DD/MM/YYYY HH:mm') : ''}
                    </TableCell>
                  </TableRow>
                ))}
                {props.data.length === 0 && (
                  <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell colSpan={9} align="center">ไม่พบข้อมูล</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
});

export default PrintSells;